import LoadingPage from "views/Base/LoadingPage";
import CatalogOutlet from "./CatalogOutlet";
import { Suspense } from "react";
import { Layout } from "antd";

export default function Catalog(): React.ReactElement {
  return (
    <Layout className="layout-card">
      <Suspense fallback={<LoadingPage />}>
        <CatalogOutlet />
      </Suspense>
    </Layout>
  );
}
